/**
 * Star Map Customizer - Basic UI Interactions
 * This file contains only the basic tab switching and UI interaction functionality.
 * Star chart rendering will be added in a separate file.
 */

(function() {
    'use strict';

    // Size to aspect ratio mapping (height/width)
    const sizeRatios = {
        '30x40cm': 1.333,
        '40x50cm': 1.25,
        '40x60cm': 1.5,
        '50x70cm': 1.4,
        '60x80cm': 1.333,
        '70x100cm': 1.428,
        '75x100cm': 1.333,
        // Landscape versions
        '40x30cm': 0.75,
        '50x40cm': 0.8,
        '60x40cm': 0.667,
        '70x50cm': 0.714,
        '80x60cm': 0.75,
        '100x70cm': 0.7,
        '100x75cm': 0.75
    };

    // Current ratio for resize handling
    let currentRatio = 1.333;

    // Dynamically update frame overlay position based on custom-frame dimensions
    // DISABLED: Using pure CSS percentage positioning like citymap for consistent scaling
    function updateFrameOverlayPosition(size, ratio) {
        // CSS handles positioning via percentages - no JS override needed
        // This matches citymap behavior which scales correctly across viewports
        return;
    }

    // Expose for resize handling
    window.updateFrameOverlayPosition = updateFrameOverlayPosition;

    // Update frame position on window resize
    window.addEventListener('resize', function() {
        const mediaOverlay = document.querySelector('.starmap-customizer .canvas__wrapper .media');
        if (mediaOverlay) {
            const size = mediaOverlay.getAttribute('data-size');
            const ratio = parseFloat(mediaOverlay.getAttribute('data-ratio')) || 1.333;
            if (size) {
                updateFrameOverlayPosition(size, ratio);
            }
        }
    });

    // Update preview aspect ratio based on selected size
    function updatePreviewAspectRatio(size) {
        currentRatio = sizeRatios[size] || 1.333;
        const preview = document.querySelector('.starmap-customizer .single-map-view');

        if(currentRatio < 1.35){
            document.querySelector('.starmap-customizer .canvas__wrapper .single-map-view #celestial-map, .main__wrapper .outer__main .canvas__wrapper .single-map-view #celestial-map').style.maxWidth = currentRatio*70+'%';
        }else{
            document.querySelector('.starmap-customizer .canvas__wrapper .single-map-view #celestial-map, .main__wrapper .outer__main .canvas__wrapper .single-map-view #celestial-map').style.maxWidth = '100%';
        }

        if (!preview) return;

        // Only set aspect ratio on the container - flexbox CSS handles inner elements
        preview.style.aspectRatio = '1 / ' + currentRatio;

        // Update .media frame overlay with size data attribute and dynamic positioning
        const mediaOverlay = document.querySelector('.starmap-customizer .canvas__wrapper .media');
        if (mediaOverlay) {
            mediaOverlay.setAttribute('data-size', size);
            mediaOverlay.setAttribute('data-ratio', currentRatio);

            // Delay to let layout settle, then update frame position
            setTimeout(function() {
                updateFrameOverlayPosition(size, currentRatio);
            }, 100);
        }

        // Wait for layout to settle, then adjust spacing and fonts
        setTimeout(function() {
            adjustInternalSpacing(preview, currentRatio);
        }, 50);

        console.log('Aspect ratio updated:', size, 'ratio:', currentRatio);
    }

    // Dynamically adjust spacing and fonts based on aspect ratio and container size
    // Uses proportional sizing based on container dimensions
    function adjustInternalSpacing(preview, ratio) {
        const frameContainer = preview.querySelector('.frame-container');
        const customFrame = preview.querySelector('.custom-frame');
        const celestialMap = preview.querySelector('#celestial-map');
        const customTextarea = preview.querySelector('.custom-textarea');
        const customAddress = preview.querySelector('.custom-address');
        const bgImg = preview.querySelector('#bg-img-new');

        if (!frameContainer) return;

        // Get container dimensions
        const containerWidth = preview.offsetWidth;
        const containerHeight = preview.offsetHeight;

        // Check if background image is visible
        const hasBackgroundImage = bgImg && bgImg.style.display !== 'none' && bgImg.src;

        // Calculate a scaling factor based on the smaller dimension
        // This ensures fonts scale properly on different screen sizes
        const minDimension = Math.min(containerWidth, containerHeight);
        const scaleFactor = minDimension / 400; // 400px as base reference

        // Base font sizes, scaled proportionally
        // When image is present, reduce sizes to make room
        const imageReduction = hasBackgroundImage ? 0.85 : 1;

        // Font sizes - proportional to container, with min/max clamps
        const baseFontSize = Math.max(10, Math.min(18, 14 * scaleFactor * imageReduction));
        const addressFontSize = Math.max(8, Math.min(14, 11 * scaleFactor * imageReduction));

        // Padding - proportional to container width
        const extraRatio = Math.max(0, ratio - 1);
        const basePadding = hasBackgroundImage ? 1.5 : 2.5;
        const paddingPercent = basePadding + (extraRatio * 2);

        // Frame padding scales with container
        const framePadding = Math.max(10, Math.min(20, 15 * scaleFactor));
        const reducePercentage = 16;

        const calculatedFontSize = addressFontSize - (addressFontSize  * reducePercentage / 100);

        // Apply font styles
        if (customTextarea) {
            customTextarea.style.setProperty('font-size', baseFontSize + 'px', 'important');
            customTextarea.style.setProperty('line-height', '1.3', 'important');
            customTextarea.style.setProperty('flex-shrink', '1', 'important');
            customTextarea.style.setProperty('min-height', '0', 'important');
            // overflow: hidden — closes with CSS -webkit-line-clamp 3 to enforce 3-line max
            customTextarea.style.setProperty('overflow', 'hidden', 'important');
        }
        if (customAddress) {
            customAddress.style.setProperty('font-size', calculatedFontSize + 'px', 'important');
            customAddress.style.setProperty('line-height', '1.4', 'important');
            customAddress.style.setProperty('flex-shrink', '1', 'important');
            customAddress.style.setProperty('min-height', '0', 'important');
        }

        // Apply padding to frame-container
        frameContainer.style.setProperty('padding-top', paddingPercent + '%', 'important');
        frameContainer.style.setProperty('padding-bottom', paddingPercent + '%', 'important');

        // Apply padding to custom-frame
        if (customFrame) {
            customFrame.style.setProperty('padding', framePadding + 'px', 'important');
        }

        // Ensure celestial map properties
        if (celestialMap) {
            //celestialMap.style.setProperty('max-width', '100%', 'important');
            celestialMap.style.setProperty('flex-shrink', '0', 'important');
        }

        console.log('Adjusted - ratio:', ratio, 'scale:', scaleFactor.toFixed(2), 'hasImage:', hasBackgroundImage, 'fontSize:', baseFontSize.toFixed(1));
    }

    // Handle window resize
    function handleResize() {
        const preview = document.querySelector('.starmap-customizer .single-map-view');
        if (preview) {
            adjustInternalSpacing(preview, currentRatio);
        }
    }

    // Debounced resize handler
    let resizeTimeout;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(handleResize, 100);
    });

    // Listen for image changes from starmap-celestial.js
    window.addEventListener('starmapImageChanged', function() {
        setTimeout(handleResize, 100);
    });

    // Wait for DOM to be ready
    document.addEventListener('DOMContentLoaded', function() {
        initStarmapUI();
    });

    function initStarmapUI() {
        // Initialize all UI components
        initTabSwitching();
        initLayoutSwitching();
        initOrientationSwitching();
        initStyleSwitching();
        initSizePicker();
        initTypePicker();
        initCheckboxes();

        // Filter sizes for initially selected type on page load
        var initialType = document.querySelector('.starmap-customizer .tab__switcher ul li a.current');
        if (initialType) {
            var typeName = initialType.getAttribute('data-type');
            var typeId = initialType.getAttribute('data-id');
            if (typeName) {
                updateSizePickerPrices(typeName);
            }
            // Hide format panels that don't match the initial type
            var formatPanels = document.querySelectorAll('.starmap-customizer .el__format');
            formatPanels.forEach(function(panel) {
                if (panel.getAttribute('data-id') === typeId) {
                    panel.style.display = (typeId === '2') ? 'flex' : 'block';
                } else {
                    panel.style.display = 'none';
                }
            });
        }
        initCustomStyleTabs();
        initFontPicker();
        initBorderPicker();
        initInfoPopups();
        initShowMore();

        // Set initial layout based on default size (CSS already has default aspect-ratio, this just confirms/updates)
        setTimeout(function() {
            const currentSize = document.querySelector('.starmap-customizer .size__picker a.current');
            if (currentSize) {
                const size = currentSize.getAttribute('data-size');
                updatePreviewAspectRatio(size);
            } else {
                // Apply default ratio
                updatePreviewAspectRatio('30x40cm');
            }
        }, 0);
    }

    /**
     * Tab Switching - Main navigation tabs
     */
    function initTabSwitching() {
        // Use direct child selector to only target the main tab navigation links
        const tabLinks = document.querySelectorAll('.starmap-customizer .main__switcher > ul > li > a[data-tab]');
        const panels = {
            'design__info': document.querySelector('.starmap-customizer .design__info'),
            'location__wrapper': document.querySelector('.starmap-customizer .location__wrapper'),
            'markers__wrapper': document.querySelector('.starmap-customizer .markers__wrapper'),
            'format__wrapper': document.querySelector('.starmap-customizer .format__wrapper'),
            'preview__wrapper': document.querySelector('.starmap-customizer .preview__wrapper')
        };

        tabLinks.forEach(function(link) {
            link.addEventListener('click', function(e) {
                e.preventDefault();

                // Remove current class from all tabs
                tabLinks.forEach(function(tab) {
                    tab.classList.remove('current');
                });

                // Add current class to clicked tab
                this.classList.add('current');

                // Get the target panel
                const targetPanel = this.getAttribute('data-tab');

                // Hide all panels
                Object.values(panels).forEach(function(panel) {
                    if (panel) {
                        panel.style.display = 'none';
                    }
                });

                // Show target panel
                if (panels[targetPanel]) {
                    panels[targetPanel].style.display = 'block';
                }

                // V9.96.27c: Beim ERSTEN Aufruf des Produkt-Tabs automatisch
                // Holzrahmen (data-id=2) auswählen — Default in Ort/Karte/Text
                // ist Mattes Poster (data-id=1), aber im Produkt-Tab wird der
                // User auf das gerahmte Premium-Produkt geleitet.
                if (targetPanel === 'format__wrapper' && !window.__starmapFormatTabVisited) {
                    window.__starmapFormatTabVisited = true;
                    const framedTile = document.querySelector('.starmap-customizer .tab__switcher ul > li > a[data-id="2"]:not(.current)');
                    if (framedTile) {
                        framedTile.click();
                    }
                }

                // Mobile: Tab-Bar an den Top scrollen, damit der neue
                // Tab-Inhalt sichtbar ist. Desktop bleibt aussen vor
                // (Switcher ist dort Flex-Sibling vom Canvas).
                if (window.matchMedia('(max-width: 991px)').matches) {
                    const sw = this.closest('.main__switcher');
                    if (sw) sw.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            });
        });
    }

    /**
     * Layout Switching - Square, Circle, Heart, Double, Triple
     */
    function initLayoutSwitching() {
        const layoutLinks = document.querySelectorAll('.starmap-customizer .elem__picker ul li a[data-layout]');

        layoutLinks.forEach(function(link) {
            link.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                // Remove current class from all layout options
                layoutLinks.forEach(function(layoutLink) {
                    layoutLink.classList.remove('current');
                });

                // Add current class to clicked layout
                this.classList.add('current');

                const layout = this.getAttribute('data-layout');
                console.log('Layout/Shape selected:', layout);

                // Handle shape change - ensure single-map-view stays visible
                handleLayoutChange(layout);
            });
        });
    }

    function handleLayoutChange(layout) {
        // Shape switching is now handled by starmap-celestial.js
        // This function now only ensures single-map-view stays visible
        const singleView = document.querySelector('.starmap-customizer .single-map-view');
        if (singleView) {
            singleView.style.display = 'block';
        }

        // Ensure design__info panel stays visible when changing shapes
        const designInfo = document.querySelector('.starmap-customizer .design__info');
        if (designInfo) {
            designInfo.style.display = 'block';
        }

        console.log('Shape selected:', layout);
    }

    /**
     * Orientation Switching - Portrait/Landscape
     */
    function initOrientationSwitching() {
        const orientationLinks = document.querySelectorAll('.starmap-customizer .type__switcher li a');

        orientationLinks.forEach(function(link) {
            link.addEventListener('click', function(e) {
                e.preventDefault();

                orientationLinks.forEach(function(orientLink) {
                    orientLink.classList.remove('current');
                });

                this.classList.add('current');

                const orientation = this.getAttribute('data-type');
                console.log('Orientation selected:', orientation);

                // Update canvas wrapper orientation
                const canvasWrapper = document.querySelector('.starmap-customizer .canvas__wrapper .media');
                if (canvasWrapper) {
                    canvasWrapper.setAttribute('data-resize-type', orientation);
                }

                // Update frame image for new orientation
                if (window.updateStarmapOrientation) {
                    window.updateStarmapOrientation(orientation);
                }
            });
        });
    }

    /**
     * Style Switching - Star map color themes
     */
    function initStyleSwitching() {
        // Style switching is now handled by starmap-celestial.js
        // This function is kept for compatibility but does minimal work
        const customStylePanel = document.querySelector('.starmap-customizer .custom__style');

        // Always hide custom style panel - we use image upload instead
        if (customStylePanel) {
            customStylePanel.style.display = 'none';
        }
    }

    /**
     * Size Picker
     */
    function initSizePicker() {
        const sizeLinks = document.querySelectorAll('.starmap-customizer .size__picker a');

        sizeLinks.forEach(function(link) {
            link.addEventListener('click', function(e) {
                e.preventDefault();

                // Only handle clicks within the visible el__format panel
                const parentFormat = this.closest('.el__format');
                if (parentFormat && parentFormat.style.display === 'none') return;

                // Remove current from all size links in the same panel
                const siblingLinks = parentFormat ?
                    parentFormat.querySelectorAll('.size__picker a') : sizeLinks;
                siblingLinks.forEach(function(sizeLink) {
                    sizeLink.classList.remove('current');
                });

                this.classList.add('current');

                const size = this.getAttribute('data-size');
                const variantId = this.getAttribute('data-variant-id');

                // Update variant and price
                updateSelectedVariant(variantId);

                // Update preview aspect ratio based on size
                updatePreviewAspectRatio(size);

                // Update hidden field for paper size
                const paperSizeHidden = document.getElementById('starmap-paper-size');
                if (paperSizeHidden) paperSizeHidden.value = size;
            });
        });
    }

    function updateSelectedVariant(variantId) {
        if (!variantId) return;

        // Update hidden variant input
        const variantInput = document.querySelector('.starmap-customizer input[name="id"]');
        if (variantInput) {
            variantInput.value = variantId;
        }

        // Find variant in product variants and update price
        if (window.productVariants) {
            const variant = window.productVariants.find(v => v.id == variantId);
            if (variant) {
                updatePriceDisplay(variant.price);
            }
        }
    }

    function updatePriceDisplay(price) {
        const priceElement = document.querySelector('.starmap-customizer .variant-price');
        if (priceElement && price) {
            // V9.96.27e: Format als "XX,XX €" (Symbol HINTER Zahl, analog Citymap V9.96.5)
            let amount;
            if (window.Shopify && window.Shopify.formatMoney) {
                let formatted = Shopify.formatMoney(price, '{{amount_with_comma_separator}}');
                // Strip currency symbols falls formatMoney sie einfügt
                amount = formatted.replace(/[€$£]|CHF\s?/g, '').trim();
            } else {
                amount = (price / 100).toFixed(2).replace('.', ',');
            }
            priceElement.textContent = amount + ' €';
            priceElement.setAttribute('data-price', price);
        }
    }

    /**
     * Type Picker - Product type (Poster, Framed, Canvas, Digital)
     */
    function initTypePicker() {
        const typeLinks = document.querySelectorAll('.starmap-customizer .tab__switcher ul li a');

        typeLinks.forEach(function(link) {
            link.addEventListener('click', function(e) {
                e.preventDefault();

                typeLinks.forEach(function(typeLink) {
                    typeLink.classList.remove('current');
                });

                this.classList.add('current');

                const typeId = this.getAttribute('data-id');
                const typeName = this.getAttribute('data-type');

                console.log('Type selected:', typeName, 'ID:', typeId);

                // Show/hide format panels
                const formatPanels = document.querySelectorAll('.starmap-customizer .el__format');
                formatPanels.forEach(function(panel) {
                    if (panel.getAttribute('data-id') === typeId) {
                        // V9.96.27f-fix4: immer block — vorher flex für id=2,
                        // aber ohne flex-direction:column → row → 3-Spalten-Bug
                        panel.style.display = 'block';
                    } else {
                        panel.style.display = 'none';
                    }
                });

                // V9.96.27f-fix: Show/hide editor-benefits-wrapper per type (analog Citymap)
                const benefitWrappers = document.querySelectorAll('.starmap-customizer .editor-benefits-wrapper');
                benefitWrappers.forEach(function(wrap) {
                    wrap.style.display = (wrap.getAttribute('data-id') === typeId) ? 'block' : 'none';
                });

                // Show/hide frame picker for framed type (id=2)
                const framePicker = document.querySelector('.starmap-customizer .frame-picker[data-type-id="2"]');
                if (framePicker) {
                    framePicker.style.display = (typeId === '2') ? 'block' : 'none';

                    // Auto-select first frame if switching to framed type and none selected
                    if (typeId === '2') {
                        const frameLinks = framePicker.querySelectorAll('ul li a');
                        const currentFrame = framePicker.querySelector('ul li a.current');
                        if (!currentFrame && frameLinks.length > 0) {
                            frameLinks[0].click();
                        } else if (currentFrame) {
                            // Trigger frame update for already selected frame
                            if (window.updateStarmapFrameImage) {
                                window.updateStarmapFrameImage();
                            }
                        }
                    }
                }

                // Update frame image visibility based on product type
                if (window.updateStarmapFrameImage) {
                    window.updateStarmapFrameImage();
                }

                // Update product type info (delivery dates, descriptions, frame picker)
                if (window.updateProductTypeInfo) {
                    window.updateProductTypeInfo(typeId);
                }

                // Update prices for selected type
                console.log('Type picker clicked, typeName:', typeName, 'typeId:', typeId);
                updateSizePickerPrices(typeName);

                // Select first available size in this format panel
                const activePanel = document.querySelector('.starmap-customizer .el__format[data-id="' + typeId + '"]');
                if (activePanel) {
                    const firstSize = activePanel.querySelector('.size__picker a');
                    if (firstSize && !activePanel.querySelector('.size__picker a.current')) {
                        firstSize.click();
                    } else {
                        // Update variant for currently selected size
                        const currentSize = activePanel.querySelector('.size__picker a.current');
                        if (currentSize) {
                            const variantId = currentSize.getAttribute('data-variant-id');
                            updateSelectedVariant(variantId);
                        }
                    }
                }

                // Update hidden field for layout type
                const layoutTypeHidden = document.getElementById('starmap-layout-type');
                if (layoutTypeHidden) layoutTypeHidden.value = typeName;
            });
        });
    }

    function updateSizePickerPrices(selectedType) {
        if (!window.productVariants) {
            console.log('updateSizePickerPrices: No productVariants found');
            return;
        }

        console.log('updateSizePickerPrices called with type:', selectedType);
        console.log('Available variants:', window.productVariants.map(v => ({ id: v.id, option2: v.option2, option1: v.option1, price: v.price })));

        document.querySelectorAll('.starmap-customizer .size__picker a').forEach(function(sizeOption) {
            const size = sizeOption.getAttribute('data-size');

            // Find variant matching this size + selected type
            const variant = window.productVariants.find(function(v) {
                return v.option2 === size && v.option1 === selectedType;
            });

            console.log(`Size ${size} + Type ${selectedType} => Variant:`, variant ? variant.id : 'NOT FOUND');

            if (variant) {
                // Update variant ID on the element
                sizeOption.setAttribute('data-variant-id', variant.id);

                // Update price display on the element
                const priceSpan = sizeOption.querySelector('.content p');
                if (priceSpan) {
                    let formattedPrice;
                    // Get currency symbol - default to Euro
                    let currencySymbol = '€';
                    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
                        const currencySymbols = { 'EUR': '€', 'USD': '$', 'GBP': '£', 'CHF': 'CHF ' };
                        currencySymbol = currencySymbols[window.Shopify.currency.active] || '€';
                    }
                    if (window.Shopify && window.Shopify.formatMoney) {
                        formattedPrice = Shopify.formatMoney(variant.price, '{{amount_with_comma_separator}}');
                        if (!formattedPrice.includes('€') && !formattedPrice.includes('$') && !formattedPrice.includes('£')) {
                            formattedPrice = currencySymbol + formattedPrice;
                        }
                    } else {
                        formattedPrice = currencySymbol + (variant.price / 100).toFixed(2).replace('.', ',');
                    }
                    priceSpan.textContent = formattedPrice;
                    console.log(`Updated price for ${size}: ${formattedPrice}`);
                }

                // Also update compare-at price if exists
                const compareSpan = sizeOption.querySelector('.content span');
                if (compareSpan && variant.compare_at_price && variant.compare_at_price > variant.price) {
                    let formattedCompare;
                    let currencySymbol = '€';
                    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
                        const currencySymbols = { 'EUR': '€', 'USD': '$', 'GBP': '£', 'CHF': 'CHF ' };
                        currencySymbol = currencySymbols[window.Shopify.currency.active] || '€';
                    }
                    if (window.Shopify && window.Shopify.formatMoney) {
                        formattedCompare = Shopify.formatMoney(variant.compare_at_price, '{{amount_with_comma_separator}}');
                        if (!formattedCompare.includes('€') && !formattedCompare.includes('$') && !formattedCompare.includes('£')) {
                            formattedCompare = currencySymbol + formattedCompare;
                        }
                    } else {
                        formattedCompare = currencySymbol + (variant.compare_at_price / 100).toFixed(2).replace('.', ',');
                    }
                    compareSpan.textContent = formattedCompare;
                    compareSpan.style.display = '';
                } else if (compareSpan) {
                    compareSpan.style.display = 'none';
                }

                sizeOption.style.display = '';
                sizeOption.classList.remove('unavailable');
            } else {
                // Hide unavailable sizes
                sizeOption.style.display = 'none';
                sizeOption.classList.add('unavailable');
                console.log(`Size ${size} marked as unavailable for type ${selectedType}`);
            }
        });

        // If the currently selected size is now unavailable, select the first available one
        const currentSize = document.querySelector('.starmap-customizer .el__format[style*="block"] .size__picker a.current, .starmap-customizer .el__format:not([style*="none"]) .size__picker a.current');
        if (currentSize && currentSize.classList.contains('unavailable')) {
            currentSize.classList.remove('current');
            const firstAvailable = currentSize.closest('.size__picker').querySelector('a:not(.unavailable)');
            if (firstAvailable) {
                firstAvailable.classList.add('current');
                firstAvailable.click();
            }
        } else if (currentSize) {
            const variantId = currentSize.getAttribute('data-variant-id');
            if (variantId) {
                updateSelectedVariant(variantId);
            }
        }
    }

    /**
     * Checkboxes - Marker, Title toggles
     */
    function initCheckboxes() {
        // Single map marker checkbox
        const markerCheckbox = document.querySelector('#single-marker');
        const markerInfo = document.querySelector('.starmap-customizer .markers__wrapper .marker__info');

        if (markerCheckbox && markerInfo) {
            markerCheckbox.addEventListener('change', function() {
                markerInfo.style.display = this.checked ? 'block' : 'none';
            });
        }

        // Single map title checkbox
        const titleCheckbox = document.querySelector('#single-title');
        const titleContent = document.querySelector('.starmap-customizer .markers__wrapper .map__title .content');

        if (titleCheckbox && titleContent) {
            titleCheckbox.addEventListener('change', function() {
                titleContent.style.display = this.checked ? 'block' : 'none';
            });
        }

        // Constellation checkboxes
        initConstellationCheckboxes();
    }

    function initConstellationCheckboxes() {
        const constellationCheckbox = document.querySelector('#show-constellations');
        const starNamesCheckbox = document.querySelector('#show-star-names');
        const gridCheckbox = document.querySelector('#show-grid');

        // These will control star chart rendering options
        // Actual rendering will be in a separate file
    }

    /**
     * Custom Style Tabs - Background, Stars, Lines colors
     */
    function initCustomStyleTabs() {
        const customTabs = document.querySelectorAll('.starmap-customizer .custom__style .switcher a');
        const customBoxes = document.querySelectorAll('.starmap-customizer .custom__style .box');

        customTabs.forEach(function(tab) {
            tab.addEventListener('click', function(e) {
                e.preventDefault();

                customTabs.forEach(function(t) {
                    t.classList.remove('current');
                });

                this.classList.add('current');

                const targetId = this.getAttribute('data-id');

                customBoxes.forEach(function(box) {
                    if (box.getAttribute('data-id') === targetId) {
                        box.style.display = 'block';
                    } else {
                        box.style.display = 'none';
                    }
                });
            });
        });

        // Color picker clicks
        const colorLinks = document.querySelectorAll('.starmap-customizer .custom__style .box .wrap a');
        colorLinks.forEach(function(link) {
            link.addEventListener('click', function(e) {
                e.preventDefault();

                const parentBox = this.closest('.box');
                if (parentBox) {
                    parentBox.querySelectorAll('.wrap a').forEach(function(a) {
                        a.classList.remove('current');
                    });
                }

                this.classList.add('current');
            });
        });
    }

    /**
     * Font Picker
     */
    function initFontPicker() {
        const fontLinks = document.querySelectorAll('.starmap-customizer .font__picker .font-options-grid li a');

        fontLinks.forEach(function(link) {
            link.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                const parentPicker = this.closest('.font__picker');
                if (parentPicker) {
                    parentPicker.querySelectorAll('.font-options-grid li a').forEach(function(a) {
                        a.classList.remove('current');
                    });
                }

                this.classList.add('current');

                const font = this.getAttribute('data-font');
                console.log('Font selected:', font);

                // Update font in preview
                if (typeof updatePreviewFont === 'function') {
                    updatePreviewFont(font);
                }
            });
        });
    }

    /**
     * Border Picker
     */
    function initBorderPicker() {
        const borderLinks = document.querySelectorAll('.starmap-customizer .border__picker .border-options li a');

        borderLinks.forEach(function(link) {
            link.addEventListener('click', function(e) {
                e.preventDefault();

                borderLinks.forEach(function(borderLink) {
                    borderLink.classList.remove('current');
                });

                this.classList.add('current');

                const border = this.getAttribute('data-border');
                console.log('Border selected:', border);
            });
        });
    }

    /**
     * Info Popups
     */
    function initInfoPopups() {
        const infoButtons = document.querySelectorAll('.starmap-customizer .info__button');
        const popups = document.querySelectorAll('.starmap-customizer .info__popup');

        infoButtons.forEach(function(button) {
            button.addEventListener('click', function(e) {
                e.preventDefault();

                const popupId = this.getAttribute('data-id');
                const popup = document.querySelector('.starmap-customizer .info__popup[data-id="' + popupId + '"]');

                if (popup) {
                    popup.style.display = 'block';
                }
            });
        });

        // Close popup buttons
        popups.forEach(function(popup) {
            const closeBtn = popup.querySelector('.top a');
            if (closeBtn) {
                closeBtn.addEventListener('click', function(e) {
                    e.preventDefault();
                    popup.style.display = 'none';
                });
            }
        });
    }

    /**
     * Show More toggle for descriptions
     */
    function initShowMore() {
        const showMoreLinks = document.querySelectorAll('.starmap-customizer .show__more a');

        showMoreLinks.forEach(function(link) {
            link.addEventListener('click', function(e) {
                e.preventDefault();

                const estimated = this.closest('.estimated');
                if (estimated) {
                    const descList = estimated.querySelector('.product-description');
                    if (descList) {
                        descList.classList.toggle('expanded');
                        this.textContent = descList.classList.contains('expanded') ? 'Weniger anzeigen' : 'Mehr anzeigen';
                    }
                }
            });
        });
    }

    /**
     * Navigate to format tab
     */
    window.navigateToFormatTab = function() {
        const formatTab = document.querySelector('.starmap-customizer .main__switcher a[data-tab="format__wrapper"]');
        if (formatTab) {
            formatTab.click();
        }
    };

    /**
     * Close the print preview modal
     */
    window.closeStarmapPreviewModal = function(event) {
        if (event) event.preventDefault();
        const modal = document.getElementById('print-preview-modal');
        if (modal) {
            modal.close();
            document.body.style.overflow = '';
        }
    };

    /**
     * Confirm preview and add to cart (called from modal button)
     */
    window.starmapConfirmAndAddToCart = function(event) {
        if (event) event.preventDefault();
        closeStarmapPreviewModal();
        const cartBtn = document.querySelector('.starmap-customizer .cart-btn');
        if (cartBtn) {
            cartBtn.click();
        }
    };

    /**
     * Background Style Toggle and Selection
     */
    function initBackgroundStylePicker() {
        const backgroundToggle = document.getElementById('enable-background-style');
        const backgroundGrid = document.getElementById('background-style-grid');
        const customFrame = document.querySelector('.starmap-customizer .custom-frame');

        if (!backgroundToggle || !backgroundGrid) return;

        // Handle toggle checkbox
        backgroundToggle.addEventListener('change', function() {
            if (this.checked) {
                // Show the background grid
                backgroundGrid.style.display = 'grid';
                backgroundGrid.style.setProperty('display', 'grid', 'important');

                // Auto-click the first background option
                const firstBackground = backgroundGrid.querySelector('a');
                if (firstBackground) {
                    firstBackground.click();
                }
            } else {
                // Hide the background grid
                backgroundGrid.style.display = 'none';
                backgroundGrid.style.setProperty('display', 'none', 'important');

                // Remove background from preview
                if (customFrame) {
                    customFrame.style.backgroundImage = '';
                }

                // Update hidden field
                const hiddenField = document.getElementById('starmap-background-image');
                if (hiddenField) hiddenField.value = '';
            }
        });

        // Handle background selection
        const backgroundLinks = backgroundGrid.querySelectorAll('a');
        backgroundLinks.forEach(function(link) {
            link.addEventListener('click', function(e) {
                e.preventDefault();

                // Remove current class from all
                backgroundLinks.forEach(function(l) {
                    l.classList.remove('current');
                });

                // Add current class to clicked
                this.classList.add('current');

                // Get background URL
                const bgUrl = this.getAttribute('data-bg');

                // Apply to preview
                if (customFrame && bgUrl) {
                    customFrame.style.backgroundImage = 'url("' + bgUrl + '")';
                    customFrame.style.backgroundSize = 'cover';
                    customFrame.style.backgroundPosition = 'center';
                }

                // Update hidden field
                const hiddenField = document.getElementById('starmap-background-image');
                if (hiddenField) hiddenField.value = bgUrl || '';

                console.log('Background selected:', bgUrl);
            });
        });
    }

    // Initialize background picker
    initBackgroundStylePicker();

})();

/**
 * Ideas/Inspiration Popup functionality for Starmap
 * Using jQuery - must be outside the IIFE to work with jQuery ready
 */
(function($) {
    if (typeof $ === 'undefined') return;

    $(document).ready(function() {
        // Close ideas popup
        $('.ideas__wrapper .top>a').on('click', function(e) {
            e.preventDefault();
            $(this).closest('.ideas__wrapper').fadeOut(300);
            $('body,html').css('overflow-y', 'initial');
        });

        // Open ideas popup
        $('.open__popup--ideas').on('click', function(e) {
            e.preventDefault();
            $('.ideas__wrapper').fadeIn(300);
            $('body,html').css('overflow-y', 'hidden');

            // Show first category by default
            $('.ideas__wrapper .content>ul>li>a').first().addClass('current');
            $('.ideas__wrapper .list .elem[data-id="1"]').fadeIn(300);
        });

        // Switch between idea categories
        $('.ideas__wrapper .content>ul>li>a').on('click', function(e) {
            e.preventDefault();
            if (!$(this).hasClass('current')) {
                $(this).closest('ul').find('.current').removeClass('current');
                $(this).addClass('current');
                $('.ideas__wrapper .list .elem').css('display', 'none');
                $('.ideas__wrapper .list .elem[data-id="' + $(this).attr('data-id') + '"]').fadeIn(300);
            }
        });

        // Select an idea - update textarea and preview
        $(document).on('click', '.ideas__wrapper .list .elem .idea-item', function(e) {
            e.preventDefault();
            const ideaText = $(this).closest('.elem').attr('data-message');

            // Update the message textarea
            const messageTextarea = document.getElementById('textMessage');
            if (messageTextarea) {
                messageTextarea.value = ideaText;

                // Trigger input event to update character count
                messageTextarea.dispatchEvent(new Event('input', { bubbles: true }));
            }

            // Update the preview custom-textarea
            const customTextarea = document.getElementById('custom-textarea');
            if (customTextarea) {
                // Replace line breaks and slashes with <br> tags
                const formattedText = ideaText.replace(/\//g, '<br>').replace(/\n/g, '<br>');
                customTextarea.innerHTML = formattedText;
            }

            // Close the popup
            $('.ideas__wrapper').fadeOut(300);
            $('body,html').css('overflow-y', 'initial');
        });
    });

    // Tab-Help Glühbirne Toggle (sync alle Tabs)
    $(document).on('click', '.tab-help__toggle', function(e) {
        e.preventDefault();
        var $thisContent = $(this).closest('.tab-help').next('.tab-help__content');
        var isCurrentlyVisible = $thisContent.is(':visible');
        if (isCurrentlyVisible) {
            $('.tab-help__content').slideUp(300);
            $('.tab-help__toggle').removeClass('is-active');
        } else {
            $('.tab-help__content').slideDown(300);
            $('.tab-help__toggle').addClass('is-active');
        }
    });
    $(document).on('click', '.tab-help__close a', function(e) {
        e.preventDefault();
        $('.tab-help__content').slideUp(300);
        $('.tab-help__toggle').removeClass('is-active');
    });

    // V9.96.9: Glühbirne default AUS — User-Wunsch, Konfigurator soll mit
    // eingeklapptem Hilfetext starten. Toggle bleibt funktional.
})(jQuery);
